import { Environment, type EnvironmentConfig, type RelayFieldLogger } from 'relay-runtime';

import { getSharedRelayEnvironmentConfig } from '@atlassian/relay-environment-config';
import type { NetworkOptions } from '@atlassian/relay-network';

type Props = {
	log?: EnvironmentConfig['log'];
	requiredFieldLogger?: RelayFieldLogger;
	networkOptions?: NetworkOptions;
	network?: EnvironmentConfig['network'];
	/**
	 * @deprecated Do not override that option, it's here only for Townsquare backwards compatibility and will be removed soon.
	 */
	getDataID?: EnvironmentConfig['getDataID'];
};

type AtlassianRelayEnvironment = Environment;

export function createRelayEnvironment(environmentOptions: Props): AtlassianRelayEnvironment;

export function createRelayEnvironment(
	environmentOptions: Omit<Props, 'networkOptions'>,
): AtlassianRelayEnvironment;

export function createRelayEnvironment(
	environmentOptions: Omit<Props, 'networkOptions' | 'network'>,
): AtlassianRelayEnvironment;

export function createRelayEnvironment(environmentOptions: Props): AtlassianRelayEnvironment {
	const options = getSharedRelayEnvironmentConfig(environmentOptions);

	return new Environment(options);
}
